import React from "react";

import BaseAdmin from "./BaseAdmin";
import { Card, Row, Col,Input, Icon,InputNumber,Form,Popconfirm, Button, Table, message } from "antd";
import {Auth, API} from "aws-amplify";

const EditableContext = React.createContext();

class EditableCell extends React.Component{
  getInput = () => {
    if (this.props.inputType === 'number') {
      return (<InputNumber />);
    }
    return (<Input />);
  };



  renderCell = ({ getFieldDecorator }) => {
      const {editing, dataIndex, title, inputType, record, index, children, ...restProps} = this.props;

      return (
          <td {...restProps}>
              {editing ? (
                  <Form.Item style={{ margin: 0 }}>
                      {getFieldDecorator(dataIndex, {
                      rules: [
                          {
                          required: true,
                          message: `${title} requerido!`
                          },
                      ],
                      initialValue: record[dataIndex]
                      })(this.getInput())}
                  </Form.Item>
              ) : (children)}
          </td>
      );
  };

  render() {
    return (<EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>);
  }
}

class monotributos extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            loading:true,
            monotributos:[], //categoria, maximo facturacion cat, imp bienes, imp servicios, aportes sipa,
            vencimientos:[], //nombre del mes y fecha de vencimiento. Ej: Enero:24/01, Febrero: 22/02
            otros_impuestos:[],
            editingKey:'',
            count: 0,
        };

        this.columns = [
            {
                title: "Categoria",
                dataIndex: "categoria",
                key: "categoria",
                editable: false,
                unique:true,
                width:"30%",
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                  <div style={{ padding: 8 }}>
                      <Input
                          ref={node => {
                              this.searchInput = node;
                          }}
                          placeholder="Buscar categoría"
                          value={selectedKeys[0]}
                          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                          onPressEnter={() => confirm()}
                          style={{ width: 188, marginBottom: 8, display: 'block' }}
                      />
                      <Button
                          type="primary"
                          onClick={() => confirm()}
                          icon="search"
                          size="small"
                          style={{ width: 90, marginRight: 8 }}
                      >
                          Buscar
                  </Button>
                      <Button
                          onClick={() => clearFilters()}
                          size="small"
                          style={{ width: 90 }}
                      >
                          Reset
                  </Button>
                  </div>
              ),
              filterIcon: filtered => (
                  <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
              ),
              onFilter: (value, record) => record.categoria.indexOf(value) === 0,
              onFilterDropdownVisibleChange: visible => {
                  if (visible) {
                      setTimeout(() => this.searchInput.select())
                  }
              }
            },
            {
                title: "Monto maximo facturación",
                dataIndex: "monto_facturacion_maximo",
                key: "maximoFacturacion",
                editable: true,
                width:"20%"
            },
            {
                title: "Imp. Bienes",
                dataIndex: "impuesto_bienes",
                key: "impBienes",
                editable: true,
                width:"10%"
            },
            {
                title: "Imp. Servicios",
                dataIndex: "impuesto_servicios",
                key: "impServicios",
                editable: true,
                width:"10%"
            },
            {
                title: "Aportes SIPA",
                dataIndex: "aportes_sipa",
                key: "aportesSipa",
                editable: true,
                width:"10%"
            },
            {
              title: "Porcentaje OS",
              dataIndex: "porcentaje_os",
              key: "porcentaje_os",
              editable: true,
              width:"10%"
          },
            {
                title: "Operacion",
                dataIndex:"operation",
                width:"15%",
                align:'center',
                render: (text, record) => {
                    const { editingKey } = this.state;
                    const editable = this.isEditing(record);
                    return editable ? (
                      <span>
                        <EditableContext.Consumer>
                          {form => (
                            <a href="#/"
                              onClick={() => this.save_monotributos(form, record.key)}
                              style={{ marginRight: 8 }}
                            >
                              Guardar
                            </a>
                          )}
                        </EditableContext.Consumer>
                        <Popconfirm title="Desea cancelar?" onConfirm={() => this.cancel(record.key)}>
                          <a href="#/">Cancelar</a>
                        </Popconfirm>
                      </span>
                    ) : (
                      <span>
                        <a href="#/" disabled={editingKey !== ''} onClick={() => this.edit(record.key)}>
                          Editar
                        </a>
                        {/*<a disabled={editingKey !== ''} onClick={() => this.handleDelete_mono(record.key)}>
                        Eliminar
                    </a>*/}
                      </span>
                    )
                    ;
                  },
                }
              ];

        this.columns_vto = [
            {
                title: "Mes",
                dataIndex: "mes",
                key: "mes",
                editable:false
            },
            {
                title: "Día [YYYY-MM-DD]",
                dataIndex: "fecha",
                key: "fecha",
                editable: true
            },
            {
                title: "Operacion",
                dataIndex:"operation",
                width:"20%",
                align:'center',
                render: (text, record) => {
                    const { editingKey } = this.state;
                    const editable = this.isEditing(record);
                    return editable ? (
                      <span>
                        <EditableContext.Consumer>
                          {form => (
                            <a href="#/"
                              onClick={() => this.save_vto(form, record.key)}
                              style={{ marginRight: 8 }}
                            >
                              Guardar
                            </a>
                          )}
                        </EditableContext.Consumer>
                        <Popconfirm title="Desea cancelar?" onConfirm={() => this.cancel(record.key)}>
                          <a href="#/">Cancelar</a>
                        </Popconfirm>
                      </span>
                    ) : (
                      <a href="#/" disabled={editingKey !== ''} onClick={() => this.edit(record.key)}>
                        Editar
                      </a>
                    );
                  }
                },
        ];

        this.columns_otro =[
            {
                title:"Concepto",
                dataIndex:"nombre",
                key:"nombre",
                editable: false
            },
            {
                title: "Monto",
                dataIndex: "valor",
                key: "valor",
                editable: true
            },
            {
                title: "Operacion",
                dataIndex:"operation",
                width:"20%",
                align:'center',
                render: (text, record) => {
                    const { editingKey } = this.state;
                    const editable = this.isEditing(record);
                    return editable ? (
                      <span>
                        <EditableContext.Consumer>
                          {form => (
                            <a href="#/"
                              onClick={() => this.save_otro(form, record.key)}
                              style={{ marginRight: 8 }}
                            >
                              Guardar
                            </a>
                          )}
                        </EditableContext.Consumer>
                        <Popconfirm title="Desea cancelar?" onConfirm={() => this.cancel(record.key)}>
                          <a href="#/">Cancelar</a>
                        </Popconfirm>
                      </span>
                      ) : (
                        <span>
                          <a href="#/" disabled={editingKey !== ''} onClick={() => this.edit(record.key)}>
                            Editar
                          </a>
                          {/*<a disabled={editingKey !== ''} onClick={() => this.handleDelete_otro(record.key)}>
                            / Eliminar
                      </a>*/}
                        </span>
                    );
                  },
                }
        ]
            };

    isEditing = record => record.key === this.state.editingKey;


    componentDidMount() {
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/taxes/monotributos',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        let monotributos = response.monotributos.map(mono=>{
                            mono["key"]=mono["categoria"]
                            return mono
                        })
                        let vencimiento = response.vencimientos.map(vence =>{
                            vence["key"]=vence["mes"]
                            return vence
                        })
                        let otros = response.otros.map(otro=>{
                          otro["key"]=otro["nombre"]
                          return otro
                        })
                        response["vencimientos"]=vencimiento
                        response["monotributos"]=monotributos
                        response["otros_impuestos"]=otros

                        this.setState({ loading: false, monotributos: response.monotributos,vencimientos:response.vencimientos, otros_impuestos: response.otros_impuestos })
                    })

                    .catch(err => console.log(err))
            })
    }


      /*handleDelete_mono = key => {
          const columns = [...this.state.monotributos];
          this.setState({ monotributos: columns.filter(item => item.key !== key), editingKey:''});
        };

      handleDelete_otro = key => {
        const columns_otro = [...this.state.otros_impuestos];
        this.setState({ otros_impuestos: columns_otro.filter(item => item.key !== key), editingKey:''});
      };

      handleAdd_mono = () => {
        const { count, monotributos } = this.state;
        const newData = {
          key: count,
          categoria: null,
          monto_facturacion_maximo:null,
          impuesto_bienes: null,
          impuesto_servicios: null,
          aportes_sipa:null
        };

        this.setState({
          monotributos: [...monotributos, newData],
          editingKey:count
        });
      };

      handleAdd_otro = () => {
        const { count, otros_impuestos } = this.state;
        const newData = {
          key: count,
          concepto: null,
          monto:null,
        };

        this.setState({
          otros_impuestos: [...otros_impuestos, newData],
          editingKey:count
        });

      };*/

        cancel = () => {
            this.setState({ editingKey: '' });
            //this.handleDelete_mono(this.state.count)
            //this.handleDelete_otro(this.state.count)

          };

          save_monotributos(form, key) {
            form.validateFields((error, row) => {
              if (error) {
                return;
              }
              const newData = [...this.state.monotributos];
              const index = newData.findIndex(item => key === item.key);

              if (index > -1) {

                const item = newData[index];
                newData.splice(index, 1, {
                  ...item,
                  ...row
                })
                this.setState({ editingKey:'', loading:true});
                this.call_api('monotributos', newData, index)
              };
            })
          };

          save_vto(form, key) {
            form.validateFields((error, row) => {
              if (error) {
                return;
              }
              const newData_vto = [...this.state.vencimientos];
              const index_vto = newData_vto.findIndex(item => key === item.key);

              if (index_vto > -1) {
                const item_vto = newData_vto[index_vto];
                newData_vto.splice(index_vto, 1, {
                  ...item_vto,
                  ...row
                });
                this.setState({ editingKey:'', loading:true});
                this.call_api('vencimientos', newData_vto,index_vto)
              };
            })
          };

          save_otro(form, key) {
            form.validateFields((error, row) => {
              if (error) {
                return;
              }
              const newData_otro = [...this.state.otros_impuestos];
              const index_otro = newData_otro.findIndex(item => key === item.key);

              if (index_otro > -1) {
                  const item_otro = newData_otro[index_otro];
                  newData_otro.splice(index_otro, 1, {
                    ...item_otro,
                    ...row
                  });

              this.setState({ editingKey:'', loading:true});
              this.call_api('otros', newData_otro,index_otro)
              };
            })
          };

          call_api(impuesto, newData, index){
              if(impuesto === 'monotributos'){
                Auth.currentSession()
                .then(session => {
                    API.put(
                        'test',
                        '/taxes/'+impuesto,
                        {
                            headers: {
                                Authorization: session.getIdToken().getJwtToken()
                            },
                            body: {
                              categoria: newData[index].categoria,
                              monto_facturacion_maximo: newData[index].monto_facturacion_maximo,
                              impuesto_bienes: newData[index].impuesto_bienes,
                              impuesto_servicios: newData[index].impuesto_servicios,
                              aportes_sipa: newData[index].aportes_sipa,
                              porcentaje_os:newData[index].porcentaje_os
                            }
                      }
                    )
                    .then(response => {
                        message.success("Tabla de Monotributos actualizada")
                        this.setState({monotributos:newData, loading:false})

                    })
                    .catch(err => {
                        message.error("Hubo un error actualizando los datos")
                        console.log(err)
                        this.setState({ loading: false })
                    })

              })}
              else if(impuesto==='vencimientos'){
                Auth.currentSession()
                .then(session => {
                    API.put(
                        'test',
                        '/taxes/'+impuesto,
                        {
                            headers: {
                                Authorization: session.getIdToken().getJwtToken()
                            },
                            body: {
                              fecha:newData[index].fecha,
                              mes:newData[index].mes
                            }
                      }
                    )
                    .then(response => {
                        message.success("Tabla de Vencimientos actualizada")
                        this.setState({loading:false, vencimientos:newData})

                    })
                    .catch(err => {
                        message.error("Hubo un error actualizando los datos")
                        console.log(err)
                        this.setState({ loading: false })
                    })
              })

              }
              else if(impuesto==='otros'){
                Auth.currentSession()
                .then(session => {
                    API.put(
                        'test',
                        '/taxes/'+impuesto,
                        {
                            headers: {
                                Authorization: session.getIdToken().getJwtToken()
                            },
                            body: {
                              nombre:newData[index].nombre,
                              valor:newData[index].valor
                            }
                      }
                    )
                    .then(response => {
                        message.success("Tabla de otros impuestos actualizada")
                        this.setState({loading:false, otros_impuestos:newData})

                    })
                    .catch(err => {
                        message.error("Hubo un error actualizando los datos")
                        console.log(err)
                        this.setState({ loading: false })
                    })
              })
              }
        }

          edit(key) {
            this.setState({ editingKey: key });
          }

          render() {
            const components = {
              body: {
                cell: EditableCell,
              },
            };


            const columns = this.columns.map(col => {
              if (!col.editable) {
                return col;
              }
              return {
                ...col,
                onCell: record => ({
                  record,
                  inputType: col.dataIndex==='categoria'?'text':'number',
                  dataIndex: col.dataIndex,
                  title: col.title,
                  editing: this.isEditing(record),
                }),
              };
            });

            const columns_vto = this.columns_vto.map(col => {
              if (!col.editable) {
                return col;
              }
              return {
                ...col,
                onCell: record => ({
                  record,
                  inputType: col.dataIndex === 'fecha' ? 'date' : 'text',
                  dataIndex: col.dataIndex,
                  title: col.title,
                  editing: this.isEditing(record)
                }),
              };
            });

            const columns_otro = this.columns_otro.map(col => {
              if (!col.editable) {
                return col;
              }
              return {
                ...col,
                onCell: record => ({
                  record,
                  inputType: col.dataIndex === 'valor' ? 'number' : 'text',
                  dataIndex: col.dataIndex,
                  title: col.title,
                  editing: this.isEditing(record)
                }),
              };
            });
          //const hide_button = this.state.editingKey === ''?false:true;

    return(

            <BaseAdmin
                selected="monotributos"
            >
              <Row gutter={[8,8]}>
                <Col lg={24}>
                <Card style={{marginTop:10, marginBottom:5, marginLeft:5, marginRight:5}}
                title={"Información monotributos"}>
                <EditableContext.Provider value={this.props.form}>
                <Table
                    components={components}
                    columns={columns}
                    dataSource={this.state.monotributos}
                    rowClassName={"editable-row"}
                    pagination={{
                        showSizeChanger: true,
                        onChange: this.cancel,
                        hideOnSinglePage: true,
                        pageSizeOptions: ['5', '10','20', '50','100'],
                        defaultPageSize: 5,
                    }}
                    loading={this.state.loading}
                    scroll={{ x: "max-content" }}
                />
                </EditableContext.Provider>
                {/*<Button
                hidden = {hide_button}
                onClick = {this.handleAdd_mono}>
                  Agregar categoria
                </Button>*/}
                </Card>
                </Col>
              </Row>

                <Row gutter={[8,8]}>

                  <Col lg={12}>
                  <Card
                  title={'Vencimientos monotributos'}
                  style={{marginTop:10, marginBottom:5, marginLeft:5, marginRight:5}}>
                  <EditableContext.Provider value={this.props.form}>
                  <Table
                      components={components}
                      columns={columns_vto}
                      dataSource={this.state.vencimientos}
                      rowClassName={"editable-row"}
                      pagination={{
                          showSizeChanger: false,
                          onChange: this.cancel,
                          pageSizeOptions: ['5', '10','20'],
                          defaultPageSize: 12,
                          hideOnSinglePage: false
                      }}
                      loading={this.state.loading}
                      scroll={{ x: "max-content" }}
                  />
                  </EditableContext.Provider>
                  </Card>
                  </Col>
                  <Col lg={12}>
                  <Card
                  title={'Otros impuestos'}
                  style={{marginTop:10, marginBottom:5, marginLeft:5, marginRight:5}}>
                  <EditableContext.Provider value={this.props.form}>
                  <Table
                      components={components}
                      columns={columns_otro}
                      dataSource={this.state.otros_impuestos}
                      rowClassName={"editable-row"}
                      pagination={{
                          showSizeChanger: false,
                          onChange: this.cancel,
                          pageSizeOptions: ['5', '10', '20'],
                          defaultPageSize: 5,
                          hideOnSinglePage: false
                      }}
                      loading={this.state.loading}
                      scroll={{ x: "max-content" }}
                  />
                  </EditableContext.Provider>
                  {/*<Button
                    onClick = {this.handleAdd_otro}>
                    Agregar impuesto
                  </Button>*/}
                  </Card>
                  </Col>
                </Row>

            </BaseAdmin>
        );
    }
}
const EditableFormTable = Form.create()(monotributos);

export default EditableFormTable;